"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.weak-map");
var _layout = _interopRequireDefault(require("@/layout"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
/**
 * 会员权益（一级）
 * - 每月福利
 * 后续可将畅饮卡等迁入此目录
 */
var memberEquitiesRouter = {
  path: '/memberEquities',
  component: _layout.default,
  redirect: '/memberEquities/monthlyWelfare',
  name: 'MemberEquities',
  alwaysShow: true,
  meta: {
    title: '会员权益',
    icon: 'peoples'
  },
  children: [{
    path: 'monthlyWelfare',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/basic/monthlyWelfare'));
      });
    },
    name: 'MonthlyWelfare',
    meta: {
      title: '每月福利',
      icon: ''
    }
  }]
};
var _default = exports.default = memberEquitiesRouter;